import RolesChecker from "features/customer/components/RolesChecker";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ContractingMultiStepFormSection from "features/contracting/sections/ContractingMultiStepFormSection";
import { loadModule } from "features/shared/helpers/modules";
import ContractingStepConfiguration from "../models/ContractingStepConfiguration";
import { useSearchParams } from "features/shared/hooks/useSearchParams";
import { useHistory } from "react-router-dom";
import { hasContractingIdInQueryParams } from "features/contracting/helpers/contractingFormHelper";

const contractingSteps = loadModule<ContractingStepConfiguration[]>(
  "contracting/contractingSteps.json"
);

const ContractingAddPage = () => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");

  // router
  const queryParams = useSearchParams();
  const history = useHistory();

  // side-effects
  useEffect(() => {
    // allow adding only if is filled contractingId
    if (!hasContractingIdInQueryParams(queryParams)) {
      history.push("/contracting");
    }
  }, [])

  // render
  return (
    <>
      <Header
        title={t("contractingAddPage.title")}
        includeBreadcrumbs
        links={[{ text: t("contracting.title"), to: "/contracting" }]}
      />
      <ModuleContent>
        <RolesChecker enabledRoles="Contributor">
          <ContractingMultiStepFormSection
            steps={contractingSteps}
            routePrefix="/contracting/add"
            enableSaveBtn={false}
            enableBackToLoginBtn={false}
          />
        </RolesChecker>
      </ModuleContent>
    </>
  );
};

export default ContractingAddPage;
